import type { SystemPoint, PointPair } from '../types';

export interface ExampleDataset {
  key: string;
  name: string;
  description: string;
  sys1: SystemPoint[];
  sys2: SystemPoint[];
  pairs: PointPair[];
}

const boundarySys1: SystemPoint[] = [
  { point: '402', north: '3972.2209', east: '5042.8287', system: 1 },
  { point: '403', north: '2748.9233', east: '5023.7539', system: 1 },
  { point: '404', north: '3349.6557', east: '4585.4292', system: 1 },
  { point: '405', north: '3350.3209', east: '5042.8287', system: 1 },
  { point: '406', north: '3350.3209', east: '5468.3287', system: 1 },
  { point: '407', north: '3615.3627', east: '5664.0916', system: 1 },
];

const boundarySys2: SystemPoint[] = [
  { point: '2', north: '20538.5541', east: '39954.7071', system: 2 },
  { point: '3', north: '19314.2665', east: '39960.3955', system: 2 },
  { point: '4', north: '19907.2708', east: '39510.3855', system: 2 },
  { point: '6', north: '19925.6381', east: '40392.5414', system: 2 },
  { point: '7', north: '20194.5044', east: '40582.6159', system: 2 },
];

const boundaryPairs: PointPair[] = [
  {
    id: 1,
    label: '402-2',
    sys1Point: '402',
    sys2Point: '2',
    n1: '3972.2209',
    e1: '5042.8287',
    n2: '20538.5541',
    e2: '39954.7071',
    weight: 1,
  },
  {
    id: 2,
    label: '403-3',
    sys1Point: '403',
    sys2Point: '3',
    n1: '2748.9233',
    e1: '5023.7539',
    n2: '19314.2665',
    e2: '39960.3955',
    weight: 1,
  },
  {
    id: 3,
    label: '404-4',
    sys1Point: '404',
    sys2Point: '4',
    n1: '3349.6557',
    e1: '4585.4292',
    n2: '19907.2708',
    e2: '39510.3855',
    weight: 1,
  },
  {
    id: 4,
    label: '406-6',
    sys1Point: '406',
    sys2Point: '6',
    n1: '3350.3209',
    e1: '5468.3287',
    n2: '19925.6381',
    e2: '40392.5414',
    weight: 1,
  },
  {
    id: 5,
    label: '407-7',
    sys1Point: '407',
    sys2Point: '7',
    n1: '3615.3627',
    e1: '5664.0916',
    n2: '20194.5044',
    e2: '40582.6159',
    weight: 1,
  },
];

const highwaySys1: SystemPoint[] = [
  { point: '18', north: '538084.380000', east: '1656341.246000', system: 1 },
  { point: '19', north: '538416.043000', east: '1656749.902000', system: 1 },
  { point: '20', north: '539467.063000', east: '1657587.441000', system: 1 },
  { point: '21', north: '540225.907000', east: '1658216.049000', system: 1 },
  { point: '22', north: '540015.649000', east: '1659131.808000', system: 1 },
  { point: '23', north: '540166.551000', east: '1659677.510000', system: 1 },
  { point: '24', north: '540356.640000', east: '1659384.551000', system: 1 },
  { point: '25', north: '540335.237000', east: '1659031.932000', system: 1 },
  { point: '26', north: '540888.708000', east: '1658359.694000', system: 1 },
  { point: '27', north: '541121.172000', east: '1657911.153000', system: 1 },
  { point: '28', north: '540963.956000', east: '1657780.514000', system: 1 },
  { point: '29', north: '541206.940000', east: '1657162.169000', system: 1 },
  { point: '30', north: '541454.059000', east: '1657175.901000', system: 1 },
  { point: '31', north: '542066.385000', east: '1656835.769000', system: 1 },
  { point: '32', north: '543266.216000', east: '1656732.579000', system: 1 },
];

const highwaySys2: SystemPoint[] = [
  { point: '842', north: '1632.323853', east: '12567.622948', system: 2 },
  { point: '843', north: '1689.265314', east: '12627.129532', system: 2 },
  { point: '844', north: '1327.611101', east: '12973.194085', system: 2 },
  { point: '845', north: '1779.480008', east: '12757.859611', system: 2 },
  { point: '846', north: '1795.229571', east: '12790.909303', system: 2 },
  { point: '847', north: '2156.724696', east: '12618.641724', system: 2 },
  { point: '848', north: '1936.656619', east: '12953.193492', system: 2 },
  { point: '849', north: '1968.172176', east: '12973.922916', system: 2 },
  { point: '850', north: '1748.484520', east: '13308.394759', system: 2 },
  { point: '851', north: '2138.496685', east: '13218.814682', system: 2 },
  { point: '852', north: '2157.619792', east: '13302.072529', system: 2 },
  { point: '853', north: '2401.377396', east: '13246.084981', system: 2 },
  { point: '854', north: '2329.098818', east: '13485.518024', system: 2 },
  { point: '855', north: '2435.694409', east: '13517.696447', system: 2 },
  { point: '856', north: '2146.580098', east: '14475.428619', system: 2 },
  { point: '857', north: '2529.386624', east: '13551.146647', system: 2 },
  { point: '858', north: '2780.255236', east: '13655.047995', system: 2 },
  { point: '859', north: '2397.448711', east: '14579.329966', system: 2 },
  { point: '860', north: '3028.244524', east: '13802.841305', system: 2 },
  { point: '861', north: '3793.707046', east: '14424.679818', system: 2 },
  { point: '862', north: '3604.130139', east: '14657.479532', system: 2 },
  { point: '863', north: '3897.164276', east: '14722.794959', system: 2 },
  { point: '864', north: '3823.867304', east: '15051.637867', system: 2 },
  { point: '865', north: '3433.155122', east: '14964.550630', system: 2 },
  { point: '866', north: '3664.240855', east: '15291.413873', system: 2 },
  { point: '867', north: '3591.350352', east: '15342.945992', system: 2 },
  { point: '868', north: '3764.664652', east: '15588.093424', system: 2 },
  { point: '869', north: '3746.822121', east: '15887.787859', system: 2 },
  { point: '870', north: '3758.717142', east: '15687.991569', system: 2 },
  { point: '871', north: '3934.873686', east: '15592.970937', system: 2 },
  { point: '872', north: '3889.971686', east: '15509.728161', system: 2 },
  { point: '873', north: '4110.167367', east: '15390.952370', system: 2 },
  { point: '874', north: '3911.102490', east: '15239.403694', system: 2 },
  { point: '875', north: '3970.836916', east: '15160.940282', system: 2 },
  { point: '876', north: '3413.455261', east: '14736.603988', system: 2 },
  { point: '877', north: '4049.894336', east: '15029.316994', system: 2 },
  { point: '878', north: '4171.570951', east: '14764.758362', system: 2 },
  { point: '879', north: '4489.790488', east: '14911.114866', system: 2 },
  { point: '880', north: '4458.748266', east: '14562.230529', system: 2 },
  { point: '881', north: '4551.033157', east: '14554.019418', system: 2 },
  { point: '882', north: '4528.860142', east: '14304.816320', system: 2 },
  { point: '883', north: '4687.038328', east: '14110.977501', system: 2 },
  { point: '884', north: '4528.478174', east: '13981.587744', system: 2 },
  { point: '885', north: '4749.927635', east: '13710.213398', system: 2 },
  { point: '886', north: '4766.318110', east: '13360.334486', system: 2 },
  { point: '887', north: '5013.422589', east: '13371.910376', system: 2 },
  { point: '888', north: '5040.912595', east: '12771.937671', system: 2 },
  { point: '889', north: '5483.261966', east: '13178.201108', system: 2 },
  { point: '890', north: '5623.449937', east: '13025.561085', system: 2 },
  { point: '891', north: '6286.973994', east: '13634.956243', system: 2 },
  { point: '892', north: '6823.357894', east: '12911.133789', system: 2 },
];

const highwayPairs: PointPair[] = [
  {
    id: 1,
    label: '842-18',
    sys1Point: '18',
    sys2Point: '842',
    n1: '538084.380000',
    e1: '1656341.246000',
    n2: '1632.323853',
    e2: '12567.622948',
    weight: 1,
  },
  {
    id: 2,
    label: '849-19',
    sys1Point: '19',
    sys2Point: '849',
    n1: '538416.043000',
    e1: '1656749.902000',
    n2: '1968.172176',
    e2: '12973.922916',
    weight: 1,
  },
  {
    id: 3,
    label: '860-20',
    sys1Point: '20',
    sys2Point: '860',
    n1: '539467.063000',
    e1: '1657587.441000',
    n2: '3028.244524',
    e2: '13802.841305',
    weight: 1,
  },
  {
    id: 4,
    label: '861-21',
    sys1Point: '21',
    sys2Point: '861',
    n1: '540225.907000',
    e1: '1658216.049000',
    n2: '3793.707046',
    e2: '14424.679818',
    weight: 1,
  },
  {
    id: 5,
    label: '867-22',
    sys1Point: '22',
    sys2Point: '867',
    n1: '540015.649000',
    e1: '1659131.808000',
    n2: '3591.350352',
    e2: '15342.945992',
    weight: 1,
  },
  {
    id: 6,
    label: '869-23',
    sys1Point: '23',
    sys2Point: '869',
    n1: '540166.551000',
    e1: '1659677.510000',
    n2: '3746.822121',
    e2: '15887.787859',
    weight: 1,
  },
  {
    id: 7,
    label: '871-24',
    sys1Point: '24',
    sys2Point: '871',
    n1: '540356.640000',
    e1: '1659384.551000',
    n2: '3934.873686',
    e2: '15592.970937',
    weight: 1,
  },
  {
    id: 8,
    label: '874-25',
    sys1Point: '25',
    sys2Point: '874',
    n1: '540335.237000',
    e1: '1659031.932000',
    n2: '3911.102490',
    e2: '15239.403694',
    weight: 1,
  },
  {
    id: 9,
    label: '880-26',
    sys1Point: '26',
    sys2Point: '880',
    n1: '540888.708000',
    e1: '1658359.694000',
    n2: '4458.748266',
    e2: '14562.230529',
    weight: 1,
  },
  {
    id: 10,
    label: '883-27',
    sys1Point: '27',
    sys2Point: '883',
    n1: '541121.172000',
    e1: '1657911.153000',
    n2: '4687.038328',
    e2: '14110.977501',
    weight: 1,
  },
  {
    id: 11,
    label: '884-28',
    sys1Point: '28',
    sys2Point: '884',
    n1: '540963.956000',
    e1: '1657780.514000',
    n2: '4528.478174',
    e2: '13981.587744',
    weight: 1,
  },
  {
    id: 12,
    label: '886-29',
    sys1Point: '29',
    sys2Point: '886',
    n1: '541206.940000',
    e1: '1657162.169000',
    n2: '4766.318110',
    e2: '13360.334486',
    weight: 1,
  },
  {
    id: 13,
    label: '887-30',
    sys1Point: '30',
    sys2Point: '887',
    n1: '541454.059000',
    e1: '1657175.901000',
    n2: '5013.422589',
    e2: '13371.910376',
    weight: 1,
  },
  {
    id: 14,
    label: '890-31',
    sys1Point: '31',
    sys2Point: '890',
    n1: '542066.385000',
    e1: '1656835.769000',
    n2: '5623.449937',
    e2: '13025.561085',
    weight: 1,
  },
  {
    id: 15,
    label: '892-32',
    sys1Point: '32',
    sys2Point: '892',
    n1: '543266.216000',
    e1: '1656732.579000',
    n2: '6823.357894',
    e2: '12911.133789',
    weight: 1,
  },
];

export const EXAMPLES: ExampleDataset[] = [
  {
    key: 'boundary',
    name: 'Boundary Survey',
    description: '6 points, 5 pairs — one suspect pair',
    sys1: boundarySys1,
    sys2: boundarySys2,
    pairs: boundaryPairs,
  },
  {
    key: 'highway',
    name: 'Highway Survey',
    description: '66 points, 15 pairs — contains blunders',
    sys1: highwaySys1,
    sys2: highwaySys2,
    pairs: highwayPairs,
  },
];
